export default __webpack_public_path__ + "static/epassi-c1300ba275638d942c6c99a20fb10f67.png";